export const loginForm = () => {
    return [
        {
            fieldId: 'email',
            required: true,
            placeholder: "Digite o seu email",
            type: 'email',
        },
        {
            fieldId: 'password',
            required: true,
            placeholder: "Digite a sua senha",
            type: 'password',
        }
    ]
}

export const updatePasswordForm = () => {
    return [
        {
            fieldId: 'password',
            required: true,
            placeholder: "Digite a nova senha",
            type: 'password',
        },
        {
            fieldId: 'passwordConfirmation',
            required: true,
            placeholder: "Confirme a nova senha",
            type: 'password',
        }
    ]
}

export const passwordRequest = () => {
    return [
        {
            fieldId: 'email',
            required: true,
            placeholder: "Digite o seu email",
            type: 'email',
        }
    ]
}